import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Behera, M.D., Borate, S.N., Panda, S.N., Behera, P.R. and Roy,
              P.S., 2012. Modelling and analyzing the watershed dynamics using
              Cellular Automata (CA)&ndash;Markov model&ndash;A geo-information
              based approach.&nbsp;<em>Journal of earth system science</em>
              ,&nbsp;<em>121</em>(4), pp.1011-1024.
            </p>
            <p>
              Aithal, B.H., Setturu, B., Durgappa, S. and Ramachandra, T.V.,
              2012. Effectiveness of landscape Spatial Metrics with reference to
              the Spatial Resolution of Remote Sensing data. In&nbsp;
              <em>
                Proceedings of India Conference on Geo-spatial Technologies
                &amp; Applications 2012
              </em>
              .
            </p>
            <p>
              Bharath, S., Rajan, K.S. and Ramachandra, T.V., 2013. Land surface
              temperature responses to land use land cover dynamics.&nbsp;
              <em>Geoinfor Geostat: An Overview</em>,&nbsp;<em>54</em>,
              pp.50-78.
            </p>
            <p>
              Bharath, S., Rajan, K.S., Ramachandra, TV., 2021. Modeling Forest
              Landscape Dynamics, <em>Nova Science Publishers,</em> pp. 248,
              ISBN: 978-1-53619-594-1
            </p>
            <p>
              Bharath, S. and Ramachandra, T.V., 2021. Modeling Landscape
              Dynamics of Policy Interventions in Karnataka State, India.&nbsp;
              <em>Journal of Geovisualization and Spatial Analysis</em>,&nbsp;
              <em>5</em>(2), pp.1-23.
            </p>
            <p>
              Bharath S., Ramachandra T.V., 2021. Carbon Emissions in Karnataka
              and Scope for Sequestration. In Srikanth K.J. (eds) An In-Depth
              Look at Carbon Emissions
              <em>. Nova Science Publishers, Inc., NY, USA.</em>{" "}
              https://doi.org/10.52305/UTRF8102, ISBN: 978-1-68507-190-5
            </p>
            <p>
              Bhat, H.R., 2000. A field guide to the Medicinal Plants of
              Devarayanadurga State Forest.&nbsp;
              <em>Karnataka Forest Department, Tumkur</em>,&nbsp;<em>37</em>.
            </p>
            <p>
              Birhane, E., Ashfare, H., Fenta, A.A., Hishe, H., Gebremedhin,
              M.A. and Solomon, N., 2019. Land use land cover changes along
              topographic gradients in Hugumburda national forest priority area,
              Northern Ethiopia.&nbsp;
              <em>Remote Sensing Applications: Society and Environment</em>
              ,&nbsp;<em>13</em>, pp.61-68.
            </p>
            <p>
              Cai, Z., Wang, B., Cong, C. and Cvetkovic, V., 2020. Spatial
              dynamic modelling for urban scenario planning: A case study of
              Nanjing, China.&nbsp;
              <em>
                Environment and Planning B: Urban Analytics and City Science
              </em>
              ,&nbsp;<em>47</em>(8), pp.1380-1396.
            </p>
            <p>
              Das, P. and Pandey, V., 2019. Use of logistic regression in
              land-cover classification with moderate-resolution multispectral
              data.&nbsp;
              <em>Journal of the Indian Society of Remote Sensing</em>,&nbsp;
              <em>47</em>(8), pp.1443-1454.
            </p>
            <p>
              Das, B. and Pal, S.C., 2020. Assessment of groundwater
              vulnerability to over-exploitation using MCDA, AHP, fuzzy logic
              and novel ensemble models: a case study of Goghat-I and II blocks
              of West Bengal, India.&nbsp;<em>Environmental Earth Sciences</em>
              ,&nbsp;<em>79</em>(5), pp.1-16.
            </p>
            <p>
              dos Santos, A.R., da Silva Anjinho, P., Neves, G.L., Barbosa,
              M.A.G.A., de Assis, L.C. and Mauad, F.F., 2021. Dynamics of
              environmental conservation: Evaluating the past for a sustainable
              future.&nbsp;
              <em>
                International Journal of Applied Earth Observation and
                Geoinformation
              </em>
              ,&nbsp;<em>102</em>, p.102452.
            </p>
            <p>
              Galiatsatos, N., Donoghue, D.N., Watt, P., Bholanath, P.,
              Pickering, J., Hansen, M.C. and Mahmood, A.R., 2020. An assessment
              of global forest change datasets for national forest monitoring
              and reporting.&nbsp;<em>Remote Sensing</em>,&nbsp;<em>12</em>(11),
              p.1790.
            </p>
            <p>
              Harris, N.L., Goldman, E., Gabris, C., Nordling, J., Minnemeyer,
              S., Ansari, S., Lippmann, M., Bennett, L., Raad, M., Hansen, M.
              and Potapov, P., 2017. Using spatial statistics to identify
              emerging hot spots of forest loss.&nbsp;
              <em>Environmental Research Letters</em>,&nbsp;<em>12</em>(2),
              p.024012.
            </p>
            <p>
              Kurnar, D., 2011. Monitoring forest cover changes using remote
              sensing and GIS: a global prospective. Research Journal of
              Environmental Sciences, 5(2), p.105.
            </p>
            <p>
              Lambin, E.F., 2001. Global land-use and land-cover change: what
              have we learned so far?.&nbsp;<em>Global Change News</em>,&nbsp;
              <em>46</em>, pp.27-30.
            </p>
            <p>
              Laurance, W.F., Nascimento, H.E., Laurance, S.G., Andrade, A.,
              Ewers, R.M., Harms, K.E., Luizao, R.C. and Ribeiro, J.E., 2007.
              Habitat fragmentation, variable edge effects, and the
              landscape-divergence hypothesis.&nbsp;<em>PLoS one</em>,&nbsp;
              <em>2</em>(10), p.e1017.
            </p>
            <p>
              Mairota, P., Cafarelli, B., Boccaccio, L., Leronni, V., Labadessa,
              R., Kosmidou, V. and Nagendra, H., 2013. Using landscape structure
              to develop quantitative baselines for protected area
              monitoring.&nbsp;<em>Ecological indicators</em>,&nbsp;<em>33</em>,
              pp.82-95.
            </p>
            <p>
              Mengist, W., Soromessa, T. and Feyisa, G.L., 2022. Forest
              fragmentation in a forest Biosphere Reserve: Implications for the
              sustainability of natural habitats and forest management policy in
              Ethiopia.&nbsp;<em>Resources, Environment and Sustainability</em>,
              p.100058.
            </p>
            <p>
              Ramachandra, T.V., Bharath, S., Rajan, K.S. and Chandran, S.,
              2017. Modelling the forest transition in Central Western Ghats,
              India.&nbsp;<em>Spatial Information Research</em>,&nbsp;
              <em>25</em>(1), pp.117-130.
            </p>
            <p>
              Ramachandra, T.V., Bharath, S. and Gupta, N., 2018. Modelling
              landscape dynamics with LST in protected areas of Western Ghats,
              Karnataka.&nbsp;<em>Journal of environmental management</em>
              ,&nbsp;<em>206</em>, pp.1253-1262.
            </p>
            <p>
              Ramachandra, T.V., Setturu, B., Vinay, S., Tara, N.M.,
              Subashchandran, M.D. and Joshi, N.V., 2018. Conservation and
              sustainable management of local hotspots of biodiversity. In&nbsp;
              <em>
                Geospatial Infrastructure, Applications and Technologies: India
                Case Studies
              </em>
              &nbsp;(pp. 365-383). Springer, Singapore.
            </p>
            <p>
              Ramachandra, T.V., Vinay, S., Bharath, S. and Shashishankar, A.,
              2018. Focus: Ecology and Evolution: Eco-Hydrological Footprint of
              a River Basin in Western Ghats. The Yale Journal of Biology and
              Medicine, 91(4), p.431.
            </p>
            <p>
              Ramachandra, T.V., Bharath, S. and Vinay, S., 2019. Visualisation
              of impacts due to the proposed developmental projects in the
              ecologically fragile regions-Kodagu district, Karnataka.&nbsp;
              <em>Progress in Disaster Science</em>,&nbsp;<em>3</em>, p.100038.
            </p>
            <p>
              Ramachandra, T.V., Bharath, S. and Bharath, A.H., 2020. Insights
              of Forest Dynamics for the Regional Ecological Fragility
              Assessment.&nbsp;
              <em>Journal of the Indian Society of Remote Sensing</em>,&nbsp;
              <em>48</em>(8), pp.1169-1189.
            </p>
            <p>
              Reddy, C.S., Faseela, V.S., Unnikrishnan, A. and Jha, C.S., 2019.
              Earth observation data for assessing biodiversity conservation
              priorities in South Asia.&nbsp;
              <em>Biodiversity and conservation</em>,&nbsp;<em>28</em>(8),
              pp.2197-2219.
            </p>
            <p>
              Rosa, I.M., Purves, D., Souza Jr, C. and Ewers, R.M., 2013.
              Predictive modelling of contagious deforestation in the Brazilian
              Amazon.&nbsp;<em>PloS one</em>,&nbsp;<em>8</em>(10), p.e77231.
            </p>
            <p>
              Sang, L., Zhang, C., Yang, J., Zhu, D. and Yun, W., 2011.
              Simulation of land use spatial pattern of towns and villages based
              on CA&ndash;Markov model.&nbsp;
              <em>Mathematical and Computer Modelling</em>,&nbsp;<em>54</em>
              (3-4), pp.938-943.
            </p>
            <p>
              Sant&eacute;, I., Garc&iacute;a, A.M., Miranda, D. and Crecente,
              R., 2010. Cellular automata models for the simulation of
              real-world urban processes: A review and analysis.&nbsp;
              <em>Landscape and urban planning</em>,&nbsp;<em>96</em>(2),
              pp.108-122.
            </p>
            <p>
              Tang, X., Woodcock, C.E., Olofsson, P. and Hutyra, L.R., 2021.
              Spatiotemporal assessment of land use/land cover change and
              associated carbon emissions and uptake in the Mekong River
              Basin.&nbsp;<em>Remote Sensing of Environment</em>,&nbsp;
              <em>256</em>, p.112336.
            </p>
            <p>
              Tripathi, O.P., Upadhaya, K., Tripathi, R.S. and Pandey, H.N.,
              2010. Diversity, dominance and population structure of tree
              species along fragment-size gradient of a subtropical humid forest
              of northeast India.&nbsp;
              <em>Research journal of Environmental and Earth sciences</em>
              ,&nbsp;<em>2</em>(2), pp.97-105.
            </p>
            <p>
              Twisa, S. and Buchroithner, M.F., 2019. Land-use and land-cover
              (LULC) change detection in Wami River Basin, Tanzania.&nbsp;
              <em>Land</em>,&nbsp;<em>8</em>(9), p.136.
            </p>
            <p>
              Uuemaa, E., Antrop, M., Roosaare, J., Marja, R. and Mander,
              &Uuml;., 2009. Landscape metrics and indices: an overview of their
              use in landscape research.&nbsp;
              <em>Living reviews in landscape research</em>,&nbsp;<em>3</em>(1),
              pp.1-28.
            </p>
            <p>
              Verburg, P.H., Schot, P.P., Dijst, M.J. and Veldkamp, A., 2004.
              Land use change modelling: current practice and research
              priorities.&nbsp;<em>GeoJournal</em>,&nbsp;<em>61</em>(4),
              pp.309-324.
            </p>
            <p>
              Vinay, S., Bharath, S., Bharath, H.A. and Ramachandra, T.V., 2013,
              November. Hydrologic model with landscape dynamics for drought
              monitoring. In&nbsp;
              <em>
                proceeding of: Joint International Workshop of ISPRS WG VIII/1
                and WG IV/4 on Geospatial Data for Disaster and Risk Reduction,
                Hyderabad, November
              </em>
              &nbsp;(pp. 21-22).
            </p>
            <p>
              Wu, Z., Ge, Q. and Dai, E., 2017. Modeling the relative
              contributions of land use change and harvest to forest landscape
              change in the Taihe county, China.&nbsp;<em>Sustainability</em>
              ,&nbsp;<em>9</em>(5), p.708.
            </p>
            <p>
              Zeng, C., He, J., He, Q., Mao, Y., Yu, B. 2022. Assessment of Land
              Use Pattern and Landscape Ecological Risk in the Chengdu-Chongqing
              Economic Circle, Southwestern China.&nbsp;<em>Land</em>,
              <em>11</em>(5), pp.659. https://doi.org/10.3390/land11050659
            </p>
            <p>
              Zhang, B. and Xia, C., 2022. The effects of sample size and sample
              prevalence on cellular automata simulation of urban growth.&nbsp;
              <em>International Journal of Geographical Information Science</em>
              ,&nbsp;<em>36</em>(1), pp.158-187.
            </p>
            <p>
              Zhu, W., Zhang, J., Cui, Y. and Zhu, L., 2020. Ecosystem carbon
              storage under different scenarios of land use change in Qihe
              catchment, China.&nbsp;<em>Journal of Geographical Sciences</em>
              ,&nbsp;<em>30</em>(9), pp.1507-1522.
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
